import { NavLink } from 'react-router-dom';
import { UtensilsCrossed, ShoppingBag, Heart, User } from 'lucide-react';

import { useCart } from '@/store/cart.store';
import { useFavorites } from '@/store/favorites.store';

const items = [
  { to: '/menu', icon: UtensilsCrossed, label: 'Меню' },
  { to: '/favorites', icon: Heart, label: 'Избранное', kind: 'fav' as const },
  { to: '/cart', icon: ShoppingBag, label: 'Корзина', kind: 'cart' as const },
  { to: '/profile', icon: User, label: 'Профиль' },
];

export function BottomNav() {
  const cartCount = useCart((s) => s.count());
  const favCount = useFavorites((s) => s.ids.length);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-slate-100 safe-bottom">
      <ul className="grid grid-cols-4 max-w-lg mx-auto">
        {items.map(({ to, icon: Icon, label, kind }) => {
          const badge = kind === 'cart' ? cartCount : kind === 'fav' ? favCount : 0;
          return (
            <li key={to}>
              <NavLink
                to={to}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-0.5 py-2 text-[11px] ${isActive ? 'text-brand-600' : 'text-slate-500'}`
                }
              >
                <div className="relative">
                  <Icon size={22} />
                  {badge > 0 && (
                    <span className="absolute -top-1 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-brand-600 text-white text-[10px] font-bold flex items-center justify-center">
                      {badge}
                    </span>
                  )}
                </div>
                {label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
